import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavRow = forwardRef((props, ref) => {
  const { as = 'div', children, ...rest } = props
  const Comp = as
  return (
    <Comp className="dev_dash__top-nav__row" ref={ref} {...rest}>
      {children}
    </Comp>
  )
})

TopNavRow.displayName = 'TopNavRow'

TopNavRow.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
